import { Body1, Flex, Subtitle2 } from '@myphx-engineering/phx-design-system';

export type DisplayValue = { display: string; value: string };

export const PlanMemberDisplayValue = ({ item }: { item: DisplayValue }) => {
    return (
        <Flex gap="xxs">
            <Subtitle2>
                {item.display}
                {': '}
            </Subtitle2>
            <Body1 data-testid="plan-member-detail">{item.value}</Body1>
        </Flex>
    );
};
